import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { reducers as signUpReducers } from './signup.reducers';

export enum SignUpMode {
  Social,
  Credentials,
  None,
}

export interface SignUpVerification {
  loading: boolean;
  emailVerified: boolean;
}

export interface ISignUpForm {
  validEmail: boolean;
  emailChecked: boolean;
  loading: boolean;
  signUpMode: SignUpMode;
}

export interface ISignUpByEmail {
  email?: string;
  loading: boolean;
  showReCaptchaV2: boolean;
}

export interface IResendByEmail {
  showReCaptchaV2: boolean;
}

export interface ISignUpState {
  form: ISignUpForm;
  verification: SignUpVerification;
  signUpByEmail: ISignUpByEmail;
  resendByEmail: IResendByEmail;
}

const initialState: ISignUpState = {
  form: {
    validEmail: false,
    emailChecked: false,
    loading: false,
    signUpMode: SignUpMode.None
  },
  verification: {
    loading: false,
    emailVerified: false
  },
  signUpByEmail: {
    loading: false,
    showReCaptchaV2: false
  },
  resendByEmail: {
    showReCaptchaV2: false
  }
};

const signUpSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {
    clearEmailErrors: (state) => {
      state.form.validEmail = false;
      state.form.emailChecked = false;
      state.form.loading = false;
    },
    setSignUpMode: (state, action: PayloadAction<SignUpMode>) => {
      state.form.signUpMode = action.payload;
    },
    onEmailVerification: (state) => {
      state.verification.loading = true;
      state.verification.emailVerified = false;
    },
    onEmailVerificationSuccess: (state) => {
      state.verification.loading = false;
      state.verification.emailVerified = true;
    },
    onEmailVerificationFailure: (state) => {
      state.verification.loading = initialState.verification.loading;
      state.verification.emailVerified = initialState.verification.emailVerified;
    }
  },
  extraReducers: {
    ...signUpReducers
  }
});

export const {
  clearEmailErrors,
  setSignUpMode,
  onEmailVerification,
  onEmailVerificationSuccess,
  onEmailVerificationFailure
} = signUpSlice.actions;

export default signUpSlice.reducer;
